import { useEffect, useState } from 'react';

import { XIcon } from '@zola/zola-ui/src/components/SvgIconsV3/X';

import { useSearchedLocation } from '~/contexts/SearchContext';
import type { LocationOrAllMarketsType } from '~/types/responseTypes';

import { Container, CloseButton, ScreenReaderText, StyledLabel } from './EditLocationModal.styles';
import LocationDropdown from './LocationDropdown';

export type EditLocationModalProps = {
  hideModalFn: () => void;
  /** Optional callback to take additional action on setting location */
  onSelect?: (location: LocationOrAllMarketsType) => void;
};

const EditLocationModal = ({
  hideModalFn,
  onSelect = () => null,
}: EditLocationModalProps): JSX.Element => {
  const [locationDropdownInput, setLocationDropdownInput] = useState('');
  const { setSearchedLocation } = useSearchedLocation();

  useEffect(() => {
    const close = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        hideModalFn();
      }
    };
    window.addEventListener('keydown', close, true);
    return () => {
      window.removeEventListener('keydown', close, true);
    };
  }, [hideModalFn]);

  const handleSelection = (location: LocationOrAllMarketsType) => {
    hideModalFn();
    setSearchedLocation(location);
    onSelect(location);
  };

  return (
    <Container>
      <CloseButton onClick={hideModalFn}>
        <XIcon height={24} width={24} />
        <ScreenReaderText>Close</ScreenReaderText>
      </CloseButton>
      <StyledLabel useLabel labelFor="location-dropdown" labelText="Location" />
      <LocationDropdown
        id="location-dropdown"
        selectedLocation={null}
        updateSelectedLocation={handleSelection}
        inputString={locationDropdownInput}
        setInputString={setLocationDropdownInput}
        selectedTaxonomyNode={null}
        shouldCloseDropdown
        shouldFocusOnMount
        isClpTest
        placeholder="Enter location"
      />
    </Container>
  );
};

export default EditLocationModal;
